import React from "react";
import { Login } from "../features";
import { Grid } from "@material-ui/core";

function LoginPage() {
  return (
    <>
      <Login.Container />
    </>
  );
}

export default LoginPage;